import React from "react";
import { Skeleton } from "antd";

//locals
import OrgConfigDetails from "./components/OrgConfigDetails";

const OrgConfigView = ({
  currentuser,
  currentOrg,
  org,
  selectedOrg,
  paymentInfo,
  invoiceList,
  loading,
  cardModal,
  setNonce,
  tableLoading,
  totalPaid,
  totalUnpaid,
  totalTransacation,
  onChangeOrg,
  onChange,
  updateOrg,
  parentState,
  changeLocationMap,
  locationList,
  onCsvUploadComplete,
  createLocation,
  createTargetingLocation,
  updateTargetingLocation,
  deleteLocation,
  editRetailLocation,
  resetParentState,
  updateOrgLocation,
  shouldClearShapes,
  toggleShouldClearShapes,
  cartProvider,
  orgMedias,
  createOrgMedia,
  updateOrgMedia,
  onChangeStateValue,
  creativeName,
  orgMediasLoading,
  onDeleteMedia,
  onDeleteMedias,
  onLoadingDeleteMedias,
  onCreateAdgroup,
  adGroupCreatives,
  orgTableConfig,
  onChangeSwitchOrg,
  updateOrgSettings,
  orgThemeConfig,
  orgSendEmailConfig,
  onChangeColorOrg,
  selectedLocations,
  onSubmitAudience,
  attributionAudienceName,
  onDeleteAdgroup,
  onLoadingDeleteAdGroup,
  onTestTags,
  onTestTagLoading,
  updateOrgDataConfig,
  updateOrgSendEmailConfig,
  selectedTab,
  google,
  isTargetingPreviewModalOpen,
  targetingLocationsPreviewData,
  closeTargetingPreviewModal,
  bulkImportTargetingLocations,
  selectTargetingLocationPreview,
  targetingAudiences,
  deleteAudienceLocation,
  deleteBulkLocation,
  handleSubmitRegionGroup,
  handleUpdateRegionGroup,
  deleteRegionGroup,
  regionGroups,
  handleSubmitIABCategoryGroup,
  iABCategoryGroups,
  deleteIABCategoryGroup,
  campaignOrders,
  options,
  multipleTags,
  onCreateMultiTags,
  onEditMultiTags,
  onDeleteMultiOrgTag,
  handleAmplifyCampaign,
  setDefaultAmplifyCreatives,
  setAudienceAmplifyDefault,
  setOrgTagConfigAmplifyDefault,
  currentAmplifyCampaign,
  handleUpdateAmplify,
  activateHashedEmailList,
  createHashedEmailAddress,
  createHashedEmailList,
  updateHashedEmailList,
  hashedEmailLists,
  deleteHashedEmailAddress,
  deleteHashedEmailList,
  bulkCreateHashedEmailAddress,
  refetchHashedEmailLists,
  attributionAudiences,
  bulkCreateOrgMedia,
  loadingHashedEmailList,
  orgId,
  updateAdGroup,
  dealIds,
  createDealId,
  deleteDealIds,
  updateDealId,
  onSwitchChange,
  onChangeDataConfigValue,
  presetRegionGroups,
  presetRegionGroupsLoading,
  orgVideoMedias,
  refetchVideoMedias,
  refetchMedias,
  processDeviceIds,
}) => {
  return (
    <React.Fragment>
      {selectedOrg ? (
        <OrgConfigDetails
          setDefaultAmplifyCreatives={setDefaultAmplifyCreatives}
          setAudienceAmplifyDefault={setAudienceAmplifyDefault}
          setOrgTagConfigAmplifyDefault={setOrgTagConfigAmplifyDefault}
          currentuser={currentuser}
          org={org}
          selectedOrg={selectedOrg}
          paymentInfo={paymentInfo}
          invoiceList={invoiceList}
          loading={loading}
          cardModal={cardModal}
          setNonce={setNonce}
          tableLoading={tableLoading}
          totalPaid={totalPaid}
          totalUnpaid={totalUnpaid}
          totalTransacation={totalTransacation}
          onChangeOrg={onChangeOrg}
          onChange={onChange}
          updateOrg={updateOrg}
          parentState={parentState}
          changeLocationMap={changeLocationMap}
          locationList={locationList}
          onCsvUploadComplete={onCsvUploadComplete}
          createLocation={createLocation}
          createTargetingLocation={createTargetingLocation}
          updateTargetingLocation={updateTargetingLocation}
          deleteLocation={deleteLocation}
          editRetailLocation={editRetailLocation}
          resetParentState={resetParentState}
          updateOrgLocation={updateOrgLocation}
          shouldClearShapes={shouldClearShapes}
          toggleShouldClearShapes={toggleShouldClearShapes}
          cartProvider={cartProvider}
          orgMedias={orgMedias}
          createOrgMedia={createOrgMedia}
          updateOrgMedia={updateOrgMedia}
          onChangeStateValue={onChangeStateValue}
          creativeName={creativeName}
          orgMediasLoading={orgMediasLoading}
          onDeleteMedia={onDeleteMedia}
          onDeleteMedias={onDeleteMedias}
          onLoadingDeleteMedias={onLoadingDeleteMedias}
          onCreateAdgroup={onCreateAdgroup}
          adGroupCreatives={adGroupCreatives}
          onDeleteAdgroup={onDeleteAdgroup}
          onLoadingDeleteAdGroup={onLoadingDeleteAdGroup}
          orgTableConfig={orgTableConfig}
          onChangeSwitchOrg={onChangeSwitchOrg}
          updateOrgSettings={updateOrgSettings}
          orgThemeConfig={orgThemeConfig}
          orgSendEmailConfig={orgSendEmailConfig}
          onChangeColorOrg={onChangeColorOrg}
          selectedLocations={selectedLocations}
          onSubmitAudience={onSubmitAudience}
          attributionAudienceName={attributionAudienceName}
          onTestTags={onTestTags}
          onTestTagLoading={onTestTagLoading}
          updateOrgDataConfig={updateOrgDataConfig}
          updateOrgSendEmailConfig={updateOrgSendEmailConfig}
          selectedTab={selectedTab}
          google={google}
          isTargetingPreviewModalOpen={isTargetingPreviewModalOpen}
          targetingLocationsPreviewData={targetingLocationsPreviewData}
          closeTargetingPreviewModal={closeTargetingPreviewModal}
          bulkImportTargetingLocations={bulkImportTargetingLocations}
          selectTargetingLocationPreview={selectTargetingLocationPreview}
          targetingAudiences={targetingAudiences}
          deleteAudienceLocation={deleteAudienceLocation}
          deleteBulkLocation={deleteBulkLocation}
          handleSubmitRegionGroup={handleSubmitRegionGroup}
          handleUpdateRegionGroup={handleUpdateRegionGroup}
          deleteRegionGroup={deleteRegionGroup}
          regionGroups={regionGroups}
          handleSubmitIABCategoryGroup={handleSubmitIABCategoryGroup}
          iABCategoryGroups={iABCategoryGroups}
          deleteIABCategoryGroup={deleteIABCategoryGroup}
          campaignOrders={campaignOrders}
          options={options}
          multipleTags={multipleTags}
          onCreateMultiTags={onCreateMultiTags}
          onEditMultiTags={onEditMultiTags}
          onDeleteMultiOrgTag={onDeleteMultiOrgTag}
          handleAmplifyCampaign={handleAmplifyCampaign}
          currentAmplifyCampaign={currentAmplifyCampaign}
          handleUpdateAmplify={handleUpdateAmplify}
          activateHashedEmailList={activateHashedEmailList}
          createHashedEmailList={createHashedEmailList}
          updateHashedEmailList={updateHashedEmailList}
          deleteHashedEmailAddress={deleteHashedEmailAddress}
          deleteHashedEmailList={deleteHashedEmailList}
          hashedEmailLists={hashedEmailLists}
          refetchHashedEmailLists={refetchHashedEmailLists}
          createHashedEmailAddress={createHashedEmailAddress}
          bulkCreateHashedEmailAddress={bulkCreateHashedEmailAddress}
          attributionAudiences={attributionAudiences}
          bulkCreateOrgMedia={bulkCreateOrgMedia}
          loadingHashedEmailList={loadingHashedEmailList}
          orgId={orgId}
          updateAdGroup={updateAdGroup}
          dealIds={dealIds}
          createDealId={createDealId}
          deleteDealIds={deleteDealIds}
          updateDealId={updateDealId}
          currentOrg={currentOrg}
          onSwitchChange={onSwitchChange}
          onChangeDataConfigValue={onChangeDataConfigValue}
          presetRegionGroups={presetRegionGroups}
          presetRegionGroupsLoading={presetRegionGroupsLoading}
          processDeviceIds={processDeviceIds}
          orgVideoMedias={orgVideoMedias}
          refetchVideoMedias={refetchVideoMedias}
          refetchMedias={refetchMedias}
        />
      ) : (
        <Skeleton avatar paragraph={{ rows: 10 }} />
      )}
    </React.Fragment>
  );
};

export default OrgConfigView;
